import { Pipe, PipeTransform } from '@angular/core';
import { ProductPoint } from 'src/app/core/model/product/product-point';
import { UserSaleGroup } from 'src/app/core/model/user/user-sale-group';

@Pipe({
  name: 'showCreditsIcon',
})
export class ShowCreditsIconPipe implements PipeTransform {
  transform(value: UserSaleGroup | ProductPoint): boolean {
    if ((value as UserSaleGroup).sales) {
      return this.showUserSaleGroupIcon(value as UserSaleGroup);
    }

    return this.showProductCreditIcon(value as ProductPoint);
  }

  private showUserSaleGroupIcon(value: UserSaleGroup): boolean {
    let show = false;

    value.sales?.forEach((sale) => {
      show = show || (sale.credits !== null && sale.credits > 0);
    });

    return show;
  }

  private showProductCreditIcon(value: ProductPoint): boolean {
    return value.credits !== null && value.credits > 0;
  }
}
